import { type ReactNode } from 'react';

export interface PageHeadingProps {
    title: string;
    description?: string;
    meta?: ReactNode;
}

/** Standard heading block for inner pages (Home, admin screens). */
export function PageHeading({ title, description, meta }: PageHeadingProps) {
    return (
        <div className="mb-4">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                <h1 className="h3 mb-0">{title}</h1>
                {meta && <div className="text-body-secondary">{meta}</div>}
            </div>
            {description && <p className="text-body-secondary mt-2 mb-0">{description}</p>}
        </div>
    );
}
